import { doc, getDoc } from "firebase/firestore";

import { firestore } from "./FirebaseService";

let bccEmailsCache = null;

export const getBccEmails = async () => {
  if (bccEmailsCache !== null) {
    return bccEmailsCache;
  }
  const docRef = doc(firestore, "appConfig", "cloudConfig");
  const docSnap = await getDoc(docRef);
  const bccEmails = docSnap.exists() && Array.isArray(docSnap.data().bccEmails)
    ? docSnap.data().bccEmails
    : [];
  bccEmailsCache = bccEmails;
  return bccEmails;
};
